import React, { useEffect } from 'react';
import usePerson from './UsePerson';
import PersonForm from './PersonForm';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { Collapse, Col, Form, Row, Alert, CloseButton, Modal, Button, Fade, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import Input from 'components/common/Input';
import UploadFiles from 'components/common/UploadFiles';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Consult = ({ getPerson, entities, err }) => {
 const {
  reset,
  watch,
  register,
  setError,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: {} });

 const onError = e => console.log(e, 'este es el error que surje');

 const onSubmitData = async data => {
  getPerson(data);
  //console.log('se esta enviando el formulario ', data);
 };

 useEffect(() => {
  reset({ docType: '', docNumber: '' });
 }, [entities]);

 useEffect(() => {
  if (err) {
   reset({ docType: '', docNumber: '' });
   setError('docNumber', { types: { required: true } });
   setError('docType', { types: { required: true } });
   handleSubmit(onSubmitData, onError)();
  }
 }, [err]);

 return (
  <Flex className="fs--2 mt-2 mt-sm-0" alignItems="center" wrap="nowrap">
   <Input
    type="select"
    name="docType"
    placeholder="Documento"
    errors={errors}
    formGroupProps={{ className: 'me-2' }}
    formControlProps={{
     ...register('docType', {
      required: true,
      validate: val => !entities.some(e => e?.docType == val && e?.docNumber == watch('docNumber')) || 'Ya existe en la liata'
     }),
     size: 'sm'
    }}
    options={[
     { label: 'C. Ciudadanía', value: 'CC' },
     { label: 'C. Extranjera', value: 'CE' },
     { label: 'Pasaporte', value: 'PP' },
     { label: 'Nit', value: 'NIT' },
     { label: 'Permiso Especial', value: 'PEP' },
     { label: 'C. Venezolana', value: 'CCVE' }
    ]}
   />
   <Input
    type="text"
    name="docNumber"
    errors={errors}
    formGroupProps={{ className: 'me-2' }}
    formControlProps={{
     ...register('docNumber', {
      required: true,
      validate: val => !entities.some(e => e?.docNumber == val && e?.docType == watch('docType')) || 'Ya existe en la liata'
     }),
     size: 'sm',
     onFocus: ({ target }) => target.select()
    }}
   />

   <IconButton
    icon="search"
    className="m-0 fs--1 me-2"
    classText="d-none d-sm-block"
    transform="shrink-2"
    size="sm"
    variant="falcon-default"
    onClick={() => handleSubmit(onSubmitData, onError)()}
    //disabled={entitys.some(e => e.docType == watch('docType') && e.docNumber == watch('docNumber'))}
   >
    Consutar
   </IconButton>
  </Flex>
 );
};

const Entity = ({ entity, editEntity, deleteEntity }) => {
 return (
  <Flex className="fs--2 hover-actions-trigger" alignItems="center" wrap="wrap">
   <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '35px', height: '35px' }}>
    <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
    <FontAwesomeIcon
     icon={entity?.nit ? 'building' : 'user-tie'}
     className="fa-inverse fa-stack-1x fs-0 text-primary"
     ransform="shrink-3"
    />
   </span>
   <div className="flex-fill">
    <h6 className="mb-0 text-primary text-capitalize text-truncate" style={{ maxWidth: '200px' }}>
     <span className="p-0">
      {entity?.nit ? entity?.name?.toLowerCase() : entity?.firstName?.toLowerCase() + ' ' + entity?.lastName?.toLowerCase()}
     </span>
    </h6>
    <p className="mb-0">
     {entity?.nit ? 'nit: ' + entity.nit : 'cc: ' + entity.docNumber} - cel: {entity.phone}
    </p>
   </div>
   <div className="flex-fill d-none d-sm-block">
    <h6 className="mb-0">
     <span className="pe-3">{entity?.nit ? entity.mail : entity.email}</span>
    </h6>
    <p className="mb-0">{entity.address}</p>
   </div>
   <div className="flex-fill d-none d-sm-block">...</div>
   {!entity?.fixed && (
    <div className="hover-actions end-0 top-50 translate-middle-y me-0 me-md-2">
     <Button variant="link" type="button" className="p-0 me-1 icon-item icon-item-sm" onClick={() => editEntity(entity)}>
      <FontAwesomeIcon icon="pencil-alt" />
     </Button>
     <Button variant="link" type="button" className="p-0 icon-item icon-item-sm" onClick={() => deleteEntity(entity._id)}>
      <FontAwesomeIcon icon="trash-alt" />
     </Button>
    </div>
   )}
  </Flex>
 );
};

const Person = ({ fixedEntity, Entities, limit, type, err, position, vr, title, sub, business }) => {
 const {
  getPerson,
  watch,
  register,
  setValue,
  handleSubmit,
  errors,
  show,
  setShow,
  open,
  bloq,
  onClose,
  onError,
  onSubmitData,
  isLoading,
  entities,
  editEntity,
  deleteEntity
 } = usePerson(fixedEntity, type, Entities, limit, business);

 useEffect(() => {
  if (err) setShow(true);
 }, [err]);

 const entityPosition = top => {
  if (!entities.length) return <></>;
  return (
   <ul className={classNames('list-unstyled', { 'mb-2': top, 'mb-0 mt-2': !top })}>
    {entities.map((entity, index) => (
     <li
      key={index}
      className={classNames('alert mb-0 rounded-0 py-1 px-2 border-1', {
       'mt-1': index,
       'greetings-item': !index,
       'alert-info': vr === 'info',
       'alert-primary': vr === 'primary',
       'alert-warning': vr === 'warning',
       'alert-danger': vr === 'danger',
       'alert-success': vr === 'success',
       'alert-secondary': vr === 'secondary',
       'alert-dark': vr === 'dark'
      })}
     >
      <Entity entity={entity} editEntity={editEntity} deleteEntity={deleteEntity} />
     </li>
    ))}
   </ul>
  );
 };

 return (
  <>
   {position === 'top' && entityPosition(true)}
   <Flex className="fs--2 px-2" alignItems="center" justifyContent="md-end" wrap="wrap">
    {isLoading ? (
     <Spinner animation="grow" role="status" className="me-2 ms-n1">
      <FontAwesomeIcon icon="users" className="fa-inverse fa-stack-1x fs-0" ransform="shrink-3" />
     </Spinner>
    ) : (
     <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '35px', height: '35px' }}>
      <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
      <FontAwesomeIcon icon="users-cog" className="fa-inverse fa-stack-1x fs-0 text-primary" ransform="shrink-3" />
     </span>
    )}

    <div className="flex-grow-1">
     <h6 className="mb-0 text-info">
      <span className="pe-3">{title}</span>
     </h6>
     <p className="mb-0">{sub}</p>
    </div>
    <Fade in={show}>
     <div className="d-none d-sm-block">
      <Consult getPerson={getPerson} entities={entities} err={err} />
     </div>
    </Fade>
    <Collapse in={!show} dimension="width">
     <div>
      <Button
       variant="falcon-primary"
       type="button"
       className="p-0 icon-item icon-item-sm"
       onClick={() => {
        if (limit && entities.length + 1 > limit) return;
        setShow(true);
       }}
      >
       <FontAwesomeIcon icon="user-plus" />
      </Button>
     </div>
    </Collapse>
    <Collapse in={show} dimension="width">
     <div>
      <Button variant="falcon-primary" type="button" className="p-0 icon-item icon-item-sm" onClick={() => setShow(false)}>
       <FontAwesomeIcon icon="times" />
      </Button>
     </div>
    </Collapse>
    <Fade in={show}>
     <div className={classNames('d-block d-sm-none', { 'd-none': !show })}>
      <Consult getPerson={getPerson} entities={entities} err={err} />
     </div>
    </Fade>
   </Flex>
   {position === 'bottom' && entityPosition(false)}

   <Modal show={open} onHide={onClose} className="mt-4 pb-4 pb-md-2">
    <Modal.Header className="bg-shape modal-shape-header px-4 position-relative">
     <div className="position-relative z-index-1 light">
      <h4 className="mb-0 text-white" id="authentication-modal-label">
       Entidad
      </h4>
      <p className="fs--1 mb-0 text-white">Gestiona la creacion y edicion de una persona o empresa</p>
     </div>
     <CloseButton variant="white" className="position-absolute end-0 me-2 mt-2 top-0" onClick={onClose} />
    </Modal.Header>
    <Modal.Body className="p-4">
     <Row className="mb-3">
      <Input
       type="select"
       label="Tipo doc"
       name="docType"
       placeholder="Documento"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 4 }}
       formControlProps={{ ...register('docType', { required: true }), size: 'sm', disabled: bloq }}
       options={[
        { label: 'Cedula de Ciudadanía', value: 'CC' },
        { label: 'Cedula Extranjera', value: 'CE' },
        { label: 'Permiso Especial', value: 'PEP' },
        { label: 'Cedula C. Venezolana', value: 'CCVE' }
       ]}
      />
      <Input
       type="text"
       label="Documento"
       name="docNumber"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 4 }}
       formControlProps={{ ...register('docNumber', { required: true }), size: 'sm', readOnly: bloq }}
      />

      <Input
       type="text"
       label="Expedido en"
       name="docFrom"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 4 }}
       formControlProps={{ ...register('docFrom', { required: true }), size: 'sm' }}
      />
     </Row>

     <Row className="mb-3">
      <Input
       type="text"
       label="Nombres"
       name="firstName"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 6 }}
       formControlProps={{ ...register('firstName', { required: true }), size: 'sm', readOnly: bloq }}
      />
      <Input
       type="text"
       label="Apellidos"
       name="lastName"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 6 }}
       formControlProps={{ ...register('lastName', { required: true }), size: 'sm', readOnly: bloq }}
      />
     </Row>

     <Row className="mb-3">
      <Input
       label="Movil"
       type="tel"
       name="phone"
       errors={errors}
       placeholder="Numero cel"
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, sm: 6 }}
       formControlProps={{
        size: 'sm',
        type: 'tel',
        autoComplete: 'tel',
        value: watch('phone'),
        onChange: e => setValue('phone', e)
        //countryCallingCodeEditable={true}
        //defaultCountry: 'CO'
       }}
      />
      <Form.Control
       type="hidden"
       {...register('phone', {
        required: true,
        minLength: { value: 10, message: 'Movil invalido' },
        pattern: { value: /[+0-9]/i, message: 'Solo numeros' }
       })}
      />

      <Input
       type="text"
       label="Email"
       name="email"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 6 }}
       formControlProps={{
        size: 'sm',
        className: 'input-spin-none',
        ...register('email', {
         required: true,
         pattern: {
          value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
          message: 'Email invalido'
         }
        })
       }}
      />
     </Row>

     <Row className="mb-3">
      <Input
       type="text"
       label="Ciudad"
       name="city"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 4 }}
       formControlProps={{ ...register('city', { required: true }), size: 'sm' }}
      />
      <Input
       type="text"
       label="Direccion"
       name="address"
       errors={errors}
       formLabelProps={{ className: 'mb-0 fs--2' }}
       formGroupProps={{ as: Col, lg: 8 }}
       formControlProps={{ ...register('address', { required: true }), size: 'sm' }}
      />
     </Row>

     <UploadFiles
      preview={true}
      className="mb-2"
      multiple={true}
      accept="image/*"
      dropzoneArea={true}
      files={watch('docImg')}
      style={{ height: 150 }}
      disabled={bloq && watch('docImg')?.length}
      register={register('docImg', { required: 'docImg es requerido' })}
      onChange={e => setValue('docImg', e, { shouldValidate: true, shouldTouch: true })}
      placeholder={
       <div>
        <img src={cloudUpload} alt="" width={25} className="me-2" />
        Subir imagenes del documento
       </div>
      }
     />
     {errors.docImg && (
      <Alert variant="danger">
       Debe establecer <Alert.Link>{errors?.docImg?.message}</Alert.Link>. De este proyecto.
      </Alert>
     )}
    </Modal.Body>
    <Modal.Footer>
     {isLoading && (
      <div className="p-0 flex-fill">
       <Spinner animation="grow" role="status" className="me-2 ms-n1">
        <FontAwesomeIcon icon="user" className="fa-inverse fa-stack-1x fs-0" ransform="shrink-3" />
        .........cargando...
       </Spinner>
      </div>
     )}
     <IconButton
      icon="ban"
      className="me-3"
      transform="shrink-2"
      size="sm"
      type="reset"
      variant={'falcon-default'}
      onClick={onClose}
      disabled={isLoading}
     >
      Cancelar
     </IconButton>
     <IconButton
      icon="user"
      transform="shrink-2"
      size="sm"
      variant={'falcon-default'}
      onClick={() => handleSubmit(onSubmitData, onError)()}
      disabled={isLoading}
     >
      {!watch('_id') ? 'Guardar' : 'Actualizar'}
     </IconButton>
    </Modal.Footer>
   </Modal>
  </>
 );
};

Person.Form = PersonForm;

Consult.propTypes = { getPerson: PropTypes.func, entities: PropTypes.array, err: PropTypes.bool };

Entity.propTypes = { entity: PropTypes.object, editEntity: PropTypes.func, deleteEntity: PropTypes.func };

Person.propTypes = {
 fixedEntity: PropTypes.object,
 Entities: PropTypes.func,
 limit: PropTypes.number,
 type: PropTypes.string,
 err: PropTypes.bool,
 position: PropTypes.string,
 title: PropTypes.node,
 sub: PropTypes.string,
 vr: PropTypes.string,
 business: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Person.defaultProps = { fixedEntity: {}, limit: 0, type: 'entity', business: 1, err: false, position: 'bottom', vr: 'info' };

export default Person;
